export const decimalToPercent = (value, limit) => Math.floor((value / limit) * 100)
